"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function VersusBanner() {
  const { t } = useLanguage();
  return (
    <section className="bg-[#064e3b] text-white py-16 my-12 rounded-2xl overflow-hidden">
      <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] items-stretch">
        <div className="bg-[#047857] py-12 px-8 text-center flex flex-col justify-center">
          <p className="text-xs uppercase tracking-[0.25em] text-white/80 mb-2">
            {t("blog.shutters.bannerImpactLabel")}
          </p>
          <p className="text-3xl md:text-4xl font-black text-white uppercase leading-tight">
            {t("blog.shutters.bannerImpactTitle")}
          </p>
        </div>
        <div className="flex items-center justify-center py-6 md:py-0 px-8 md:px-6">
          <span className="text-6xl md:text-8xl font-bold text-[#fbbf24]">{t("blog.shutters.bannerVs")}</span>
        </div>
        <div className="bg-[#ea580c] py-12 px-8 text-center flex flex-col justify-center">
          <p className="text-xs uppercase tracking-[0.25em] text-white/80 mb-2">
            {t("blog.shutters.bannerShutterLabel")}
          </p>
          <p className="text-3xl md:text-4xl font-black text-white uppercase leading-tight">
            {t("blog.shutters.bannerShutterTitle")}
          </p>
        </div>
      </div>
    </section>
  );
}